<div class="title-bar"></div>
<div class="base-background">
  <div class="left-polygon"></div>
  <div class="right-polygon"></div>
</div>

<div
  class="relative min-h-screen flex items-center justify-center p-4 sm:py-8 sm:px-6"
>
  <div class="w-full">
    <router-outlet></router-outlet>
  </div>

  @if (appMode === appType.PATIENT) {
  <div
    data-testid="language-toggle-wrapper"
    class="absolute flex justify-center top-[var(--p-size-2)] left-[var(--p-size-0)] sm:top-[var(--p-size-5)] sm:left-[var(--p-size-5)]"
  >
    <button
      data-testid="language-toggle"
      (click)="toggleLanguage()"
      class="text-[var(--p-color-indigo600)] px-[var(--p-spacing-4)] py-[var(--p-spacing-2)] bg-[var(--p-color-white)] inline-flex items-center justify-center rounded-[var(--p-radius-xsmall)] hover:bg-[var(--p-surface-50)] cursor-pointer transition-colors shadow-sm"
    >
      <i class="ph ph-globe me-1"></i>
      <span class="font-medium min-w-[20px]">{{ targetLanguageLabel() }}</span>
    </button>
  </div>
  }
</div>
